import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ad4',
  templateUrl: './ad4.component.html',
  styleUrls: ['./ad4.component.css']
})
export class Ad4Component implements OnInit {

  constructor( private notification: MatSnackBar ) { }

  galleryImages = []

  galleryImagesPhotoPaths = []

  @Output() stepChangeEvent = new EventEmitter<string>();

  ngOnInit(): void {

  }

  onGalleryImageChange($event){
    let images = $event.target.files
    let validImages = []
    if(images.length > 0){
      for(let image of images){
        var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
        if(filesize <= 8){
          var reader = new FileReader()
          reader.readAsDataURL(image)
          var blob = image.slice(0, image.size, 'image/png'); 
          let name = image.name
          let newImage = new File([blob], name.replace(/[^A-Z0-9.]/ig, ""), {type: 'image/png'})
          validImages.push(newImage)
          reader.onload = (_event) => { 
            this.galleryImagesPhotoPaths.push({ name: image.name, imagePath: _event.target.result})
          }
        }else{
          this.openNotification(image.name + ' file cannot exceeds 2MB!')
        }
      }
      this.galleryImages = this.galleryImages.concat(validImages)
    }
  }

  openNotification(message: string){
    this.notification.open(message , 'Cancel', {
      duration: 2000, 
      horizontalPosition: 'right'
    })
  }

  removeFromGallery(name){
    let previewIndex = this.galleryImagesPhotoPaths.indexOf(this.galleryImagesPhotoPaths.find(image => image.name == name))
    this.galleryImagesPhotoPaths.splice(previewIndex, 1)
    let galleryIndex = this.galleryImages.indexOf(this.galleryImages.find(image => image.name == name))
    this.galleryImages.splice(galleryIndex, 1)
  }

  setAsMainImage(name){
    let previewIndex = this.galleryImagesPhotoPaths.indexOf(this.galleryImagesPhotoPaths.find(image => image.name == name))
    let preview = this.galleryImagesPhotoPaths[previewIndex]
    this.galleryImagesPhotoPaths.splice(previewIndex, 1)
    this.galleryImagesPhotoPaths.unshift(preview)
    let galleryIndex = this.galleryImages.indexOf(this.galleryImages.find(image => image.name == name))
    let galleryImage = this.galleryImages[galleryIndex]
    this.galleryImages.splice(galleryIndex, 1)
    this.galleryImages.unshift(galleryImage)
  }

  next(){
    this.stepChangeEvent.emit('step-5')
  }

  previous(){
    this.stepChangeEvent.emit('step-3')
  }

}
